import React from "react";
import { Box } from "@mui/material";
import CustomButton from "../../../../UIElements/CustomButton";
import "../../../../components-styles.scss";
import "../../../profil-styles.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { phoneRegExp } from "../../../../../consts";
import InputField from "../../../../UIElements/InputField";
import CancelModalButton from "../../../../UIElements/CustomModal/CancelModalButton";

type EditPhoneNumberFormProps = {
    onSubmit: Function;
    defaultValue?: {
        phoneNumber: string;
    };
};

const validationSchema = yup.object({
    phoneNumber: yup
        .string()
        .matches(
            phoneRegExp,
            "Veuillez renseigner un numéro de téléphone valide"
        )
        .required("Veuillez renseigner un numéro de téléphone"),
});

export default function EditPhoneNumberForm({
    onSubmit,
    defaultValue,
}: EditPhoneNumberFormProps) {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            phoneNumber: defaultValue?.phoneNumber ?? "",
        },
        resolver: yupResolver(validationSchema),
    });

    const _onSubmit = (data: any) => {
        onSubmit(data);
    };

    return (
        <Box className="profil-form-root">
            <form
                onSubmit={handleSubmit(_onSubmit)}
                className="profil-form-container"
            >
                <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field: { ref, ...others } }) => (
                        <InputField
                            label={"Numéro de téléphone *"}
                            fullWidth
                            inputProps={{
                                type: "tel",
                                maxLength: 10,
                            }}
                            outlinedinputsx={{
                                border: "2px solid  #E3E6E8",
                            }}
                            {...others}
                            errortext={errors.phoneNumber?.message ?? ""}
                        />
                    )}
                />

                <CustomButton
                    type="submit"
                    label="Enregister"
                    customsx={{
                        width: "100%",
                    }}
                />
                <CancelModalButton
                    customsx={{
                        width: "100%",
                    }}
                />
            </form>
        </Box>
    );
}
